<ngx-faceavatar [src]="src_image" dim="{{ dimension }}" padding="10" rounded="true" class="imgprofile {{ aClass }}"></ngx-faceavatar>
